import {Component, Input, OnInit} from '@angular/core';
import {AuthService} from "../services/auth.service";
import {EVALUATION_ROLES, hasAnyRole, User} from "../model/user";
import {NgClass, NgIf, AsyncPipe} from '@angular/common';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {MatListModule} from '@angular/material/list';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        NgClass,
        AsyncPipe,
        RouterLink,
        RouterLinkActive,
        MatListModule
    ]
})
export class NavigationComponent implements OnInit {

  @Input()
  horizontal: boolean;

  /**
   * The evaluation section is for whoever runs it and for the production
   * companies. An evaluation admin has this link and no `/admin` menu item —
   * that pair is the role.
   */
  showsEvaluation(user: User): boolean {
    return hasAnyRole(user, [...EVALUATION_ROLES, 'producer']);
  }

  constructor(
    public auth: AuthService
  ) { }

  ngOnInit(): void {
  }

}
